<template>
  <div class="mine-appointment":class = "{'clear-header':isWechatBrowser}" style="height: 100vh;overflow: scroll;">
    <my-header v-if="!isWechatBrowser" title="我的预约" :showBack="true"></my-header>
    <mt-loadmore style="font-size: 0.25rem" :bottom-method="loadBottom" :bottom-all-loaded="allLoaded" :auto-fill ='false' bottomLoadingText = '加载更多' ref="loadmore">
    <div v-if="appointmentList.length > 0"  class="appointment-list">
      <div v-for="(appointment,index) in appointmentList" class="appointment-item">
        <img v-if="appointment.type == '1'" class="row-img" src="../../assets/appointment/icon-supervisor-cover.png" @click="openAppointmentDetail(appointment.id)">
        <img v-if="appointment.type == '2'" class="row-img" src="../../assets/appointment/icon-foreman-cover.png" @click="openAppointmentDetail(appointment.id)">
        <img v-if="appointment.type == '3'" class="row-img" src="../../assets/appointment/icon-cleaner-cover.png" @click="openAppointmentDetail(appointment.id)">
        <img v-if="appointment.type == '4'" class="row-img" src="../../assets/appointment/icon-mover-cover.png" @click="openAppointmentDetail(appointment.id)">
        <img v-if="appointment.type == '5'" class="row-img" src="../../assets/appointment/icon-onestop-cover.png" @click="openAppointmentDetail(appointment.id)">
        <img v-if="appointment.type == '6'" class="row-img" src="../../assets/appointment/icon-designer-cover.png"@click="openAppointmentDetail(appointment.id)">
        <img v-if="appointment.type == '8'" class="row-img" src="../../assets/appointment/icon-puncher-cover.png" @click="openAppointmentDetail(appointment.id)">
        <div class="row-right" @click="openAppointmentDetail(appointment.id)">
          <div v-if="appointment.type == '1' || appointment.type == '2' || appointment.type == '5' || appointment.type == '6'" class="area-name">{{appointment.areaName}}</div>
          <div v-if="appointment.type == '1' || appointment.type == '2' || appointment.type == '5' || appointment.type == '6'" class="house-type">
            <span v-if="appointment.serviceType == '3'" class="service-type">{{appointment.serviceType | serviceTypeConvert}}</span>
            <span v-if="appointment.serviceType != '3'">{{appointment.room}}室{{appointment.parlour}}厅{{appointment.toilet}}卫{{appointment.kitchen}}厨 {{appointment.houseArea}}㎡</span>
          </div>
          <div class="server-name" v-if="appointment.type == '3' || appointment.type == '4' || appointment.type == '8'">{{appointment.serverName}}</div>
          <div class="type-appointment" >{{appointment.type | appointmentTypeConvert}}</div>
        </div>
        <div v-if="appointment.status == '1'" class="appointment-btn"  @click="openAppointmentDetail(appointment.id)">业主预约</div>
        <div v-if="appointment.status == '2' && (appointment.type != '3' && appointment.type != '4' && appointment.type != '8')" @click="openAppointmentDetail(appointment.id)" class="appointment-btn status-confirm">确认预约</div>
        <div v-if="appointment.status == '2' && !(appointment.type != '3' && appointment.type != '4' && appointment.type != '8')" @click="openAppointmentDetail(appointment.id)" class="appointment-btn status-confirm">完成服务</div>
        <div v-if="appointment.status == '3' && (appointment.type != '3' && appointment.type != '4' && appointment.type != '8')" @click="openAppointmentDetail(appointment.id)" class="appointment-btn status-reject">驳回预约</div>
        <div v-if="appointment.status == '3' && !(appointment.type != '3' && appointment.type != '4' && appointment.type != '8')" @click="openAppointmentDetail(appointment.id)" class="appointment-btn status-reject">取消服务</div>
        <div v-if="appointment.status == '4'" class="appointment-btn status-confirm" @click="openAppointmentDetail(appointment.id)">量房</div>
        <div v-if="appointment.status == '5'" class="appointment-btn status-confirm" @click="openAppointmentDetail(appointment.id)">报价</div>
        <div v-if="appointment.status == '6'" class="appointment-btn status-scaling" @click="openAppointmentDetail(appointment.id)">业主定标</div>
        <div v-if="appointment.status == '7'">
          <div class="appointment-btn status-cancel">预约取消</div>
          <!--<div class="delete-btn" @click="preRemoveAppointment(appointment.id)">删除</div>-->
        </div>
        <div v-if="appointment.status == '8'" class="appointment-btn" @click="openAppointmentDetail(appointment.id)">已签约</div>
        <div v-if="appointment.status == '9'" class="appointment-btn status-create-project" @click="openAppointmentDetail(appointment.id)">已生成项目</div>
      </div>
    </div>
    </mt-loadmore>
    <div class="black-page" v-if="appointmentList.length==0">
      <img src="../../assets/icon-no-img.png">
      <div class="tip">暂无相关预约</div>
    </div>
    <div v-if="delAppointmentModal" class="toast general-tip-modal">
      <img class="close-btn" src="../../assets/icon-close-btn.png" @click="cancelDelAppointment()">
      <div class="general-modal-title border-bottom-style">温馨提示</div>
      <div class="general-modal-msg">确定要删除该预约吗？</div>
      <div class="agree-btn" @click="confirmDelAppointment()">确定</div>
    </div>
    <div v-if="delAppointmentModal" class="pay-box"></div>
  </div>
</template>
<script>
  import {Toast} from 'mint-ui'
  import Header from '../../components/header/Header'
  import session from '../../utils/Session'
  import AppointmentService from '../../service/customer/AppointmentService'

  export default {
    name: 'MineAppointment',
    components: {
      'my-header': Header,
    },
    data () {
      return {
        appointmentList:[],
        allLoaded: false,
        pageNo:1,
        autoFill:false,
        keyword:'',
        isWechatBrowser:this.$verfyBrowserType(),
        delAppointmentModal:false,
        delAppointmentId:'',
      }
    },
    beforeMount () {
      document.title = this.$route.meta.title;
      this.getAppointmentList();
    },
    methods: {
      openAppointmentDetail(id){
        this.$router.push({name:'AppointmentDetail',query:{id}});
      },
      async getAppointmentList(onCancel = function(){}){
        var result=await AppointmentService.getAppointmentList(session.getAccountToken().id,this.pageNo);
        if(result.code == '0'){
          if(this.pageNo == 1){
            this.appointmentList = [];
          }
          for(let appointment of result.data.result){
            this.appointmentList.push(appointment)
          }
          this.allLoaded = result.data.lastPage;
          onCancel();
        }else {
          Toast('获取预约列表失败');
        }
      },
      loadBottom(){
        this.pageNo++;
        this.getAppointmentList(()=>{
          this.$refs.loadmore.onBottomLoaded();
        });
      },
      preRemoveAppointment(id){
        this.delAppointmentModal= true;
        this.delAppointmentId = id;
      },
      cancelDelAppointment(){
        this.delAppointmentModal= false;
      },
      async confirmDelAppointment(){
        var result=await AppointmentService.remove(this.delAppointmentId);
        if(result.code == '0'){
          this.delAppointmentModal= false;
          Toast(result.msg);
          this.getAppointmentList();
        }else {
          Toast('删除预约失败');
        }
      }
    }
  }
</script>
<style lang="scss">
  .clear-header{
    margin-top: -1rem;
  }
  .mine-appointment{
    background: white;
    .appointment-list{
      padding-top: 0.3rem;
      font-size: 0.3rem;
      .appointment-item{
        position: relative;
        display: flex;
        width: 6.85rem;
        margin: 0 auto;
        padding-top: 0.4rem;
        padding-bottom: 0.45rem;
        border-bottom: solid 1px #eee;
        .row-img{
          width: 1.25rem;
          height: 1.25rem;
          margin-left: 0.04rem;
          border-radius: 0.1rem;
        }
        .row-right{
          margin-left: 0.28rem;
          .area-name{
            font-weight: bold;
          }
          .house-type{
            margin-top: 0.03rem;
            font-size: 0.26rem;
            color: #666;
          }
          .service-type{
            font-size: 0.36rem;
            font-weight: bold;
          }
          .type-appointment{
            max-width: 1rem;
            margin-top: 0.25rem;
            padding: 0.07rem 0.1rem;
            background: #f3f9ff;
            border-radius: 0.04rem;
            text-align: center;
            font-size: 0.24rem;
            color: #5473b3;
          }
          .appoint-tip{
            width: 1.2rem;
            height: 0.3rem;
            line-height: 0.3rem;
            text-align: center;
            margin-left: 0.2rem;
            color: #feac00;
            border-radius: 0.3rem;
            border: solid 1px #feac00;
            font-size: 0.22rem;
          }
          .server-name{
            margin-bottom: 0.2rem;
            font-size: 0.36rem;
            font-weight: bold;
          }
        }
        .appointment-btn{
          position: absolute;
          bottom: 0.45rem;
          right: 0.2rem;
          width: 1.6rem;
          height: 0.6rem;
          line-height: 0.63rem;
          background-color: #ffcf0b;
          border-radius: 0.1rem;
          text-align: center;
          font-size: 0.3rem;
        }
        .status-scaling{
          background-color: #70c285;
          color: white;
        }
        .status-confirm{
          background: #00478e;
          color: white;
        }
        .status-reject{
          background-color: #e07070;
          color: white;
        }
        .status-create-project{
          background-color: #70c285;
          color: white;
        }
        .status-cancel{
          background-color: #eeeeee;
        }
        .delete-btn{
          position: absolute;
          right: 0.2rem;
          bottom: 0.3rem;
          width: 0.8rem;
          height: 0.4rem;
          line-height: 0.43rem;
          background-color: #f7e0ae;
          text-align: center;
          border-radius: 20px;
          font-size: 0.24rem;
          color: #feac00;
        }
      }
    }
    .general-box-shadow{
      border-radius: 0.08rem;
      box-shadow: 0rem 0.02rem 0.07rem 0rem
      rgba(0, 0, 0, 0.1);
    }
    .general-tip-modal{
      width: 100%;
      height: 7rem;
      background-color: white;
      border-top-left-radius: 0.1rem;
      border-top-right-radius: 0.1rem;
      font-size: 0.32rem;
      color: #7f7d7c;
      z-index: 1002;
      .close-btn{
        position: absolute;
        width: 0.29rem;
        right: 0.3rem;
        top: 0.5rem;
      }
      .general-modal-title{
        width: 6.9rem;
        margin: 0 auto;
        line-height: 1.18rem;
        font-size: 0.36rem;
        color: #191818;
        font-weight: bold;
      }
      .general-modal-msg{
        padding-top: 0.85rem;
      }
      .agree-btn{
        width: 1.9rem;
        height: 0.7rem;
        margin: 2.18rem auto 0;
        line-height: 0.72rem;
        color: white;
        background-color: #feac00;
        border-radius: 0.7rem;
      }
    }
    .toast{
      background-color: white;
      position: fixed;
      z-index: 900;
      text-align: center;
      bottom: 0;
      left: 0;
    }
    .pay-box{
      overflow: hidden;
      position:fixed;
      top:0;
      bottom:0;
      left:0;
      right:0;
      background-color: rgba(0, 0, 0,0.3);
      z-index: 100
    }
    .black-page{
      height: 100vh;
      text-align: center;
      img{
        width: 1.57rem;
        height: 1.57rem;
        margin-top: 2.32rem;
      }
      .tip{
        margin-top: 0.4rem;
        font-size: 0.32rem;
        color: #7f7d7c;
      }
    }
  }
</style>
